import { DOWNLOAD_FILE_ERROR } from '@hunting-nature/shared-core/enums/download-file-error.enum';

// @capacitor-community/media rejects with `{ code: 'filesystemError' }` when the native write fails, e.g. when the device is out of space.
export function getDownloadFileErrorFromMediaSaveError(error: unknown): DOWNLOAD_FILE_ERROR {
  const code = (error as { code?: string } | undefined)?.code;
  return code === 'filesystemError' ? DOWNLOAD_FILE_ERROR.OUT_OF_SPACE : DOWNLOAD_FILE_ERROR.GENERIC;
}
